



















































import { Component, Mixins } from "vue-property-decorator";
import { State } from "vuex-class";
import { UserWealth } from "@foxone/api/src/models/defi";
import ContractList from "defi/components/contracts/list/Index.vue";
import EmptyContractAction from "defi/components/partial/EmptyContractAction.vue";
import Actions from "defi/components/mine/Actions.vue";
import mixins from "@/mixins";

@Component({
  components: {
    ContractList,
    Actions,
    EmptyContractAction
  }
})
class Mine extends Mixins(mixins.processOrders, mixins.scrollAppbarPage) {
  @State(state => state.defi.account.wealthes) wealthes!: UserWealth;

  @State(state => state.defi.contracts.loading) loading!: boolean;

  get title(): any {
    return this.$t("defi.mine");
  }

  get themeColor(): any {
    return "#0596FF";
  }

  get meta() {
    if (!this.wealthes) {
      return {};
    }

    const balance = (this.wealthes && this.wealthes.balance) || 0;
    const totalRevenue = (this.wealthes && this.wealthes.total_revenue) || 0;
    const lastRevenue = (this.wealthes && this.wealthes.last_revenue) || 0;
    const fiat = this.$common.utils.currency.fiat;
    const addSymbol = this.$common.utils.number.addSymbol;
    const getColor = this.$common.utils.helper.getColor;
    const totalBalanceLegal = fiat(this, {
      value: balance,
      from: "USDT"
    });
    const lastRevenueLegal = fiat(this, {
      value: lastRevenue,
      from: "USDT"
    });
    const totalRevenueLegal = fiat(this, {
      value: totalRevenue,
      from: "USDT"
    });
    return {
      balance: `${totalBalanceLegal}`,
      symbol: this.currency.unit,
      totalRevenue: addSymbol(totalRevenueLegal),
      totalRevenueColor: getColor(this.$store, this.wealthes.total_revenue),
      lastRevenue: addSymbol(lastRevenueLegal),
      lastRevenueColor: getColor(this.$store, this.wealthes.last_revenue)
    };
  }

  get currency() {
    return {
      symbol: this.$common.utils.currency.getCurrentCurrency(this.$store),
      unit: this.$common.utils.currency.getCurrenctCurrencyUnit(this.$store)
    };
  }

  mounted() {
    this.$store.dispatch("defi/contracts/loadContracts");
  }
}
export default Mine;
